<template>
    <div class="public-form-container">
        <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
        <Loading :active.sync="loading" />

        <div v-if="!dossier_no && !loading" class="result-card result-refused">
            <div class="result-icon">
                <i class="pi pi-exclamation-triangle"></i>
            </div>
            <h2>Link Inválido ou Expirado</h2>
            <p>O link que você acessou é inválido ou expirou. Por favor, entre em contato conosco para mais informações.</p>
        </div>

        <div v-else>
            <div v-if="submitted" class="result-card" :class="accepted ? 'result-accepted' : 'result-refused'">
                <div class="result-icon">
                    <i :class="accepted ? 'pi pi-check-circle' : 'pi pi-times-circle'"></i>
                </div>
                <h2>{{ accepted ? 'Proposta Aceite' : 'Proposta Recusada' }}</h2>
                <p>{{ accepted
                    ? 'A sua aceitação foi registada com sucesso. Entraremos em contacto brevemente.'
                    : 'A sua recusa foi registada. Obrigado pela sua resposta.' }}
                </p>
            </div>

            <div v-else class="form-card">

                <div class="form-header">
                    <div class="brand">
                        <div class="brand-icon">
                            <i class="pi pi-wrench"></i>
                        </div>
                        <div class="brand-text">
                            <span class="brand-name">Circuit Crafters</span>
                        </div>
                    </div>
                </div>

                <div class="form-body">
                    <div class="intro">
                        <h1>Validação de Proposta #{{ dossier_no }}</h1>
                        <p>Por favor, indique a sua decisão e, se desejar, deixe-nos uma observação.</p>
                    </div>

                    <div class="pdf-download-section">
                        <div class="pdf-info">
                            <i class="pi pi-file-pdf pdf-icon"></i>
                            <div>
                                <span class="pdf-title">Proposta Comercial #{{ dossier_no }}</span>
                                <span class="pdf-subtitle">Clique abaixo para visualizar ou descarregar o documento PDF.</span>
                            </div>
                        </div>
                        <button class="btn-download-pdf" @click="downloadPDF" type="button" :disabled="downloading">
                            <i class="pi" :class="downloading ? 'pi-spin pi-spinner' : 'pi-download'"></i>
                            <span>{{ downloading ? 'A descarregar...' : 'Descarregar PDF' }}</span>
                        </button>
                    </div>

                    <div class="field-group">
                        <label for="observations">
                            <i class="pi pi-comment"></i>
                            Observações <span class="optional">(opcional)</span>
                        </label>
                        <Textarea
                            v-model="observations"
                            :autoResize="true"
                            rows="4"
                            id="observations"
                            name="observations"
                            placeholder="Deixe aqui qualquer comentário, dúvida ou condição adicional..."
                            class="obs-textarea"
                        />
                    </div>

                    <div class="decision-area">
                        <div class="decision-label">A sua decisão:</div>
                        <div class="decision-buttons">
                            <button
                                class="btn-refuse"
                                :class="{ active: pendingDecision === false }"
                                @click="pendingDecision = false"
                                type="button"
                            >
                                <i class="pi pi-times"></i>
                                <span>Recusar Proposta</span>
                            </button>
                            <button
                                class="btn-accept"
                                :class="{ active: pendingDecision === true }"
                                @click="pendingDecision = true"
                                type="button"
                            >
                                <i class="pi pi-check"></i>
                                <span>Aceitar Proposta</span>
                            </button>
                        </div>

                        <transition name="fade">
                            <div v-if="pendingDecision !== null" class="confirm-row">
                                <div class="confirm-hint" :class="pendingDecision ? 'hint-accept' : 'hint-refuse'">
                                    <i :class="pendingDecision ? 'pi pi-info-circle' : 'pi pi-exclamation-triangle'"></i>
                                    {{ pendingDecision
                                        ? 'Ao confirmar, autoriza a avançar com a proposta.'
                                        : 'Ao confirmar, a proposta será marcada como recusada.' }}
                                </div>
                                <button class="btn-confirm" @click="sendResponse(pendingDecision)" type="button" :disabled="loading">
                                    <i class="pi pi-send"></i>
                                    {{ loading ? 'A enviar...' : 'Confirmar e Enviar' }}
                                </button>
                            </div>
                        </transition>
                    </div>
                </div>

                <div class="form-footer">
                    <i class="pi pi-lock"></i>
                    Esta resposta é segura e registada na nossa plataforma.
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import PortalService from "@/services/portal.service";

export default {
    data() {
        return {
            hash: null,
            loading: false,
            downloading: false,
            observations: "",
            pendingDecision: null,
            submitted: false,
            accepted: false,
            dossier_no: null,
        };
    },
    created() {
        this.hash = this.$route.params.hash;
        this.validateHash();
    },
    mounted() {

    },
    methods: {
        sendResponse(accepted) {
            if (this.loading) return;
            this.loading = true;

            const data = {
                hash: this.hash,
                response: accepted,
                observations: this.observations,
            };

            PortalService.sendResponseAcceptanceDossierOffer(data)
                .then(() => {
                    this.accepted   = accepted;
                    this.submitted  = true;
                })
                .catch(error => {
                    console.error("Erro ao enviar a resposta:", error);
                    this.$toast.add({
                        severity: "error",
                        summary: "Erro",
                        detail: "Não foi possível enviar a sua resposta. Tente novamente.",
                        life: 5000,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        validateHash() {
            if (!this.hash) {
                this.dossier_no = null;
                return;
            }

            PortalService.validateDossierOfferHash(this.hash)
                .then((response) => {
                    this.dossier_no = response.dossier_id;
                })
                .catch(() => {
                    this.dossier_no = null;
                    this.$toast.add({
                        severity: "error",
                        summary: "Link Inválido ou Expirado",
                        detail: "O link que você acessou é inválido ou expirou.",
                        life: 5000,
                    });
                }).finally(() => {
                    this.loading = false;
                });
        },
        downloadPDF() {
            if (this.downloading) return;
            this.downloading = true;

            PortalService.downloadDossierOfferReport(this.hash)
                .then((blob) => {
                    if (blob) {
                        const url = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = `proposta_${this.dossier_no || 'comercial'}.pdf`;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setTimeout(() => URL.revokeObjectURL(url), 100);

                        this.$toast.add({
                            severity: "success",
                            summary: "Sucesso",
                            detail: "PDF descarregado com sucesso.",
                            life: 3000,
                        });
                    } else {
                        throw new Error("Blob is null");
                    }
                })
                .catch((error) => {
                    console.error("Erro ao descarregar PDF:", error);
                    this.$toast.add({
                        severity: "error",
                        summary: "Erro",
                        detail: "Não foi possível descarregar o PDF da proposta.",
                        life: 5000,
                    });
                })
                .finally(() => {
                    this.downloading = false;
                });
        },
    },
};
</script>

<style scoped>
.public-form-container {
    min-height: 100vh;
    background: #f0f2f5;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
    font-family: 'Segoe UI', system-ui, sans-serif;
}

.form-card {
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 4px 32px rgba(0,0,0,0.10);
    width: 100%;
    max-width: 620px;
    overflow: hidden;
}

.form-header {
    background: #1a1a2e;
    padding: 1.25rem 1.75rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.brand {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}
.brand-icon {
    width: 38px;
    height: 38px;
    background: #FFCE01;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1a1a2e;
    font-size: 1rem;
}
.brand-text {
    display: flex;
    flex-direction: column;
}
.brand-name {
    font-weight: 700;
    font-size: 0.95rem;
    color: #ffffff;
    letter-spacing: 0.02em;
}
.brand-sub {
    font-size: 0.7rem;
    color: #8892a4;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}
.proposal-badge {
    background: rgba(255,206,1,0.12);
    border: 1px solid rgba(255,206,1,0.3);
    border-radius: 8px;
    padding: 0.35rem 0.85rem;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
.proposal-badge span {
    font-size: 0.6rem;
    color: #FFCE01;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}
.proposal-badge strong {
    font-size: 0.85rem;
    color: #ffffff;
    font-weight: 700;
}

.form-body {
    padding: 2rem 1.75rem;
}
.intro h1 {
    font-size: 1.35rem;
    font-weight: 700;
    color: #1a1a2e;
    margin: 0 0 0.5rem;
}
.intro p {
    font-size: 0.875rem;
    color: #5a6474;
    line-height: 1.6;
    margin: 0 0 1.75rem;
}

.field-group {
    margin-bottom: 1.5rem;
}
.field-group label {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.8rem;
    font-weight: 600;
    color: #1a1a2e;
    margin-bottom: 0.5rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}
.field-group label i {
    color: #FFCE01;
    font-size: 0.85rem;
}
.optional {
    font-weight: 400;
    color: #8892a4;
    text-transform: none;
    letter-spacing: 0;
    font-size: 0.75rem;
}

.obs-textarea {
    width: 100% !important;
    border: 1.5px solid #e2e8f0 !important;
    border-radius: 10px !important;
    font-size: 0.875rem !important;
    color: #1a1a2e !important;
    padding: 0.75rem 1rem !important;
    transition: border-color 0.2s !important;
    resize: none;
    font-family: inherit;
    box-sizing: border-box;
}
.obs-textarea:focus {
    border-color: #FFCE01 !important;
    outline: none !important;
    box-shadow: 0 0 0 3px rgba(255,206,1,0.15) !important;
}

.decision-area {
    border-top: 1.5px solid #f0f2f5;
    padding-top: 1.5rem;
}
.decision-label {
    font-size: 0.8rem;
    font-weight: 600;
    color: #1a1a2e;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 0.85rem;
}
.decision-buttons {
    display: flex;
    gap: 0.75rem;
}
.btn-refuse,
.btn-accept {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.85rem 1rem;
    border-radius: 10px;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.2s;
    font-family: inherit;
}
.btn-refuse {
    background: #fff5f5;
    border-color: #fecaca;
    color: #dc2626;
}
.btn-refuse:hover,
.btn-refuse.active {
    background: #dc2626;
    border-color: #dc2626;
    color: #fff;
    box-shadow: 0 4px 14px rgba(220,38,38,0.25);
}
.btn-accept {
    background: #f0fdf4;
    border-color: #bbf7d0;
    color: #16a34a;
}
.btn-accept:hover,
.btn-accept.active {
    background: #16a34a;
    border-color: #16a34a;
    color: #fff;
    box-shadow: 0 4px 14px rgba(22,163,74,0.25);
}

.confirm-row {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}
.confirm-hint {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    font-size: 0.8rem;
    padding: 0.65rem 0.9rem;
    border-radius: 8px;
    line-height: 1.5;
}
.hint-accept {
    background: #f0fdf4;
    color: #15803d;
    border: 1px solid #bbf7d0;
}
.hint-refuse {
    background: #fff5f5;
    color: #b91c1c;
    border: 1px solid #fecaca;
}
.btn-confirm {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.9rem;
    background: #1a1a2e;
    color: #ffffff;
    border: none;
    border-radius: 10px;
    font-size: 0.9rem;
    font-weight: 700;
    cursor: pointer;
    letter-spacing: 0.03em;
    transition: background 0.2s, box-shadow 0.2s;
    font-family: inherit;
}
.btn-confirm:hover:not(:disabled) {
    background: #2d2d4e;
    box-shadow: 0 4px 16px rgba(26,26,46,0.3);
}
.btn-confirm:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.form-footer {
    background: #f8fafc;
    border-top: 1px solid #f0f2f5;
    padding: 0.85rem 1.75rem;
    font-size: 0.72rem;
    color: #8892a4;
    display: flex;
    align-items: center;
    gap: 0.4rem;
}
.form-footer i { color: #FFCE01; }

.result-card {
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 4px 32px rgba(0,0,0,0.10);
    width: 100%;
    max-width: 420px;
    padding: 3rem 2rem;
    text-align: center;
}
.result-icon i {
    font-size: 3.5rem;
    display: block;
    margin-bottom: 1rem;
}
.result-accepted .result-icon i { color: #16a34a; }
.result-refused  .result-icon i { color: #dc2626; }
.result-card h2 {
    font-size: 1.4rem;
    font-weight: 700;
    color: #1a1a2e;
    margin: 0 0 0.75rem;
}
.result-card p {
    font-size: 0.875rem;
    color: #5a6474;
    line-height: 1.6;
    margin: 0;
}

.fade-enter-active, .fade-leave-active { transition: opacity 0.25s, transform 0.25s; }
.fade-enter, .fade-leave-to { opacity: 0; transform: translateY(-6px); }

.pdf-download-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    background: #f8fafc;
    border: 1.5px dashed #cbd5e1;
    border-radius: 12px;
    padding: 1rem 1.25rem;
    margin-bottom: 1.5rem;
    transition: border-color 0.2s, background-color 0.2s;
}
.pdf-download-section:hover {
    border-color: #FFCE01;
    background: #fffdf5;
}
.pdf-info {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}
.pdf-icon {
    font-size: 2rem;
    color: #ef4444;
}
.pdf-title {
    display: block;
    font-size: 0.9rem;
    font-weight: 700;
    color: #1a1a2e;
}
.pdf-subtitle {
    display: block;
    font-size: 0.75rem;
    color: #64748b;
}
.btn-download-pdf {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.6rem 1.1rem;
    background: #2563eb;
    color: #ffffff;
    border: none;
    border-radius: 8px;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.2s, transform 0.1s, box-shadow 0.2s;
}
.btn-download-pdf:hover:not(:disabled) {
    background: #1d4ed8;
    box-shadow: 0 4px 12px rgba(37,99,235,0.2);
}
.btn-download-pdf:active:not(:disabled) {
    transform: scale(0.97);
}
.btn-download-pdf:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

@media (max-width: 480px) {
    .form-body { padding: 1.5rem 1.25rem; }
    .form-header { padding: 1rem 1.25rem; }
    .decision-buttons { flex-direction: column; }
    .proposal-badge { display: none; }
    .pdf-download-section {
        flex-direction: column;
        align-items: stretch;
        text-align: center;
    }
    .pdf-info {
        flex-direction: column;
        gap: 0.5rem;
    }
    .btn-download-pdf {
        justify-content: center;
    }
}
</style>
